// Vuex connections module mutations types

export const FILL_LIST = 'FILL_LIST';
export const FILL_HISTORY_LIST = 'FILL_HISTORY_LIST';
export const SET_FILTERING_CRITERIA = 'SET_FILTERING_CRITERIA';
export const SET_SORTING_DIRECTION = 'SET_SORTING_DIRECTION';
export const SET_PAGE = 'SET_PAGE';
export const SET_CONNECTIONS_PER_PAGE = 'SET_CONNECTIONS_PER_PAGE';
export const CLEAR_HISTORY_LIST = 'CLEAR_HISTORY_LIST';
